import { tEnum } from '@components/i18n';

export enum PolicyTypes {
  Personal = 'personal',
  Commercial = 'commercial',
}

export const tPolicyType = (type: PolicyTypes) => tEnum('policyTypes', type);
